export default __webpack_public_path__ + "static/media/1423.b03be8c6.png";